import React from 'react';
import { useTheme } from '../theme/ThemeContext';

interface HeaderProps {
  rewardPoints: number;
  onOpenRewardsInfo: () => void;
  onOpenSettings: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  rewardPoints,
  onOpenRewardsInfo,
  onOpenSettings,
}) => {
  const { theme } = useTheme();

  return (
    <header
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '60px',
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 10,
        pointerEvents: 'none',
      }}
    >
      {/* Reward Points Pill */}
      <button
        onClick={onOpenRewardsInfo}
        style={{
          pointerEvents: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 16px',
          borderRadius: '9999px',
          backgroundColor: theme.isDark ? 'rgba(24, 24, 27, 0.85)' : 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(12px)',
          border: `1px solid ${theme.isDark ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.1)'}`,
          color: theme.textColor,
          fontFamily: '"Outfit", sans-serif',
          fontWeight: 700,
          fontSize: '16px',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        }}
      >
        <span style={{ fontSize: '18px' }}>⭐</span>
        <span>{rewardPoints}</span>
      </button>

      {/* Title */}
      <h1
        style={{
          margin: 0,
          fontFamily: '"Outfit", sans-serif',
          fontSize: '18px',
          fontWeight: 800,
          letterSpacing: '0.05em',
          color: theme.textColor,
          opacity: 0.9,
          textShadow: '0 2px 4px rgba(0,0,0,0.5)',
        }}
      >
        EXPANDING MINEFIELD
      </h1>

      {/* Settings Button */}
      <button
        onClick={onOpenSettings}
        aria-label="Settings"
        style={{
          pointerEvents: 'auto',
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          backgroundColor: theme.isDark ? 'rgba(24, 24, 27, 0.85)' : 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(12px)',
          border: `1px solid ${theme.isDark ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.1)'}`,
          color: theme.textColor,
          fontSize: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        }}
      >
        ⚙
      </button>
    </header>
  );
};
